module.exports = __webpack_public_path__ + "static/boots-27788ddb5323fa4e2da8303e8db002f9.jpg";